import { useEffect, useState, RefObject } from 'react';

interface MenuPositionProps {
  menuRef: RefObject<HTMLElement>;
  contextRef: RefObject<HTMLElement>;
}

const contentPadding = 80;
const menuTopMargin = 120;

const useMenuPosition = ({ menuRef, contextRef }: MenuPositionProps) => {
  const [isMenuFitsContainer, setIsMenuFitsContainer] = useState(false);

  useEffect(() => {
    if (menuRef.current && contextRef.current) {
      const { height: menuHeight } = menuRef.current.getBoundingClientRect();
      const { top: topPosition, height: contentHeight } = contextRef.current.getBoundingClientRect();

      const menuTotalHeight = menuHeight + menuTopMargin;
      const visibleContentHeight = contentHeight + topPosition - contentPadding;

      setIsMenuFitsContainer(visibleContentHeight <= menuTotalHeight);
    }
  }, [menuRef, contextRef]);

  return { isMenuFitsContainer };
};

export default useMenuPosition;
